<template>
<svg width="11" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 5.5L5 1.5L1 5.5" stroke="#3A3A49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>